/**
 * Copyright 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { EventActionAttempt } from "~/generated/graphql";
import { createCtx } from "~/tools";
import { EventEntity } from "~/views/events/types";
import type { EventResourceController } from "./hooks/useEventResourceController";

type Props = {
  eventAction?: EventEntity;
  attempt?: EventActionAttempt;
  setEventAction?: (eventAction: EventEntity) => void;
  setAttempt?: (attempt: EventActionAttempt) => void;
  resourceController: EventResourceController;
};

export const [useEventDetailsTab, EventDetailsTabCtxProvider] =
  createCtx<Props>();
